import { AxiosRequestConfig, AxiosResponse } from 'axios'
import _map from 'lodash/map'
import { nanoid } from 'nanoid/non-secure'

import type {
  ICheckoutCompleteDataResponse,
  IConditionsAdaptedData,
  IConditionsAdaptedDataResponse,
  IConditionsDataResponse,
  IFreeRegistrationDataResponse,
  IPaymentDataResponse,
  IPaymentSuccessDataResponse,
} from '../../types/api/payment.d'
import { isBrowser } from '../../utils/isBrowser'
import { publicRequest } from './publicRequest'

export const getPaymentData = async (hash: string): Promise<IPaymentDataResponse> => {
  const response: AxiosResponse<IPaymentDataResponse, AxiosRequestConfig> =
    await publicRequest.get(`v1/order/${hash}/review`, {
      headers: { 'Referer-Url': isBrowser && typeof document !== 'undefined' ? document.referrer : '' },
    })

  return response.data
}

export const handlePaymentSuccess = async (
  orderHash: string
): Promise<IPaymentSuccessDataResponse> => {
  const response: AxiosResponse<IPaymentSuccessDataResponse, AxiosRequestConfig> =
    await publicRequest.post(`v1/order/${orderHash}/success`, undefined, {
      headers: {
        ...publicRequest.defaults.headers.common,
        'Referer-Url': isBrowser && typeof document !== 'undefined' ? document.referrer : '',
      },
    })
  return response.data
}

export const handleFreeSuccess = async (
  orderHash: string
): Promise<IFreeRegistrationDataResponse> => {
  const response: AxiosResponse<IFreeRegistrationDataResponse, AxiosRequestConfig> =
    await publicRequest.post(
      `v1/order/${orderHash}/complete_free_registration`,
      undefined,
      { headers: { 'Referer-Url': isBrowser && typeof document !== 'undefined' ? document.referrer : '' } }
    )
  return response.data
}

export const getConfirmationData = async (
  orderHash: string
): Promise<ICheckoutCompleteDataResponse> => {
  const response: AxiosResponse<ICheckoutCompleteDataResponse, AxiosRequestConfig> =
    await publicRequest.get(`v1/order/${orderHash}/payment/complete`)
  return response.data
}

export const getConditions = async (
  eventId: string
): Promise<IConditionsAdaptedDataResponse> => {
  const response: AxiosResponse<IConditionsDataResponse, AxiosRequestConfig> =
    await publicRequest.get(`v1/event/${eventId}/conditions`)

  const adaptedData: IConditionsAdaptedData[] = _map(
    response.data.data.attributes,
    (item) => ({
      id: nanoid(),
      text: item,
      checked: false,
    })
  )

  const returnData: AxiosResponse<IConditionsAdaptedDataResponse, AxiosRequestConfig> = {
    ...response,
    data: {
      ...response.data,
      data: {
        ...response.data.data,
        attributes: adaptedData,
      },
    },
  }

  return returnData.data
}
